// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import VueTheMask from 'vue-the-mask'
import money from 'v-money'
import VueCarousel from '@chenfengyuan/vue-carousel';
import moment from 'moment'
import delivery from "./store/modules/delivery-module";
import SecureLS from "secure-ls";
import VueLazyload from 'vue-lazyload'

Vue.prototype.moment = moment
Vue.prototype.$SecureLS = new SecureLS();

Vue.use(VueCarousel);
Vue.use(VueTheMask)
Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  precision: 2,
  masked: false
})

Vue.prototype.momentJs = moment

Vue.use(VueLazyload, {
  preLoad: 1.3,
  loading: 'https://res.cloudinary.com/sirrus/image/upload/v1614611800/delivery/delivery/download_pl5ymc.png',
  error: 'https://res.cloudinary.com/sirrus/image/upload/v1614611800/delivery/delivery/error_huspix.png',
  attempt: 1,
  observer: true,
})




require('@/assets/css/materialize.css')
require('@/assets/css/style.css')
require('@/assets/css/customizacoes.css')
require('@/assets/js/materialize.js')
require('@/assets/js/init.js')

Vue.use(Vuex)

Vue.config.productionTip = false

const store = new Vuex.Store(delivery);

Vue.mixin({
  methods: {
    formatarPVenda: valor => "R$ " + parseFloat('0' + valor).toFixed(2).replace(".", ",")
  }
});

Vue.prototype.$store = store;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js